module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "free-terms-list"
    }
  }, [_c('div', {
    staticClass: "section-name-default"
  }, [_c('i', {
    staticClass: "mi mi-arrow-back btn-back",
    on: {
      "click": function($event) {
        _vm.$router.back()
      }
    }
  }), _vm._v("Lista wolnych terminów\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.freeTermsList.length),
      expression: "$store.freeTermsList.length"
    }],
    staticClass: "terms-container"
  }, [_vm._l((_vm.$store.freeTermsList), function(freeTerm) {
    return _c('free-term', {
      attrs: {
        "free-term": freeTerm,
        "type": _vm.TYPES.NEW
      }
    })
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moreAvailableTerms),
      expression: "moreAvailableTerms"
    }],
    staticClass: "btn-outline-blue btn-choose",
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.loadNextFreeTerms()
      }
    }
  }, [_vm._v("Załaduj kolejne terminy")])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$store.freeTermsList.length),
      expression: "!$store.freeTermsList.length"
    }],
    staticClass: "empty-results journal-text"
  }, [_vm._v("\n        Brak wolnych terminów...\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21026897!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FreeTermsList.vue
// module id = 204
// module chunks = 0